import PropTypes from 'prop-types';
import React from 'react';
import { Jumbotron, Button } from 'reactstrap';

class NotFound extends React.Component {

  render () {
    if(this.context && this.context.router && this.context.router.route && this.context.router.route.location && (this.context.router.route.location.pathname === "/login" || this.context.router.route.location.pathname === "/")) {
      return null;
    }
  
    return (
      <div className='page-not-found d-flex h-100 justify-content-center align-items-center'>
        <div>
          <Jumbotron>
            <h3 className='display-5'>
              <i className='fa fa-warning text-info' aria-hidden='true'></i> 404
              page not found
            </h3>
            <p className='lead'>
              We are sorry but the page you are looking for does not exist.
            </p>
            
            <div className='back-to-home-container'>
              <a className='back-to-home' href={"/app"}>Back to Home</a>
            </div>
            
          </Jumbotron>
        </div>
      </div>
    );
  }
  
};


NotFound.contextTypes = {
    router: PropTypes.object
}

export default NotFound;
